// extracted by mini-css-extract-plugin
module.exports = {"ItemList":"RelatedProducts_ItemList__u7JC3"};